module.exports = __webpack_public_path__ + "img/16081863828975.8279817c.png";